import { TableLoadingGetters, TableMutations, TableState } from '../mixins/table'

import { Actions, Module } from 'vuex-smart-module'

import { Notification, NotificationsService } from '@/api'
import { loading as loadingModule } from '@/store/modules/loading'

const loading = loadingModule.clone()

let notificationsTimer: number = null

export class NotificationsState extends TableState<Notification> {
  unreadNotifCount = 0
}

export class NotificationsGetters extends TableLoadingGetters<NotificationsActions, NotificationsState> {
  get isTableItemsGet() {
    return this.state.loading.loaders.getTableItems
  }
}

export class NotificationsMutations extends TableMutations<NotificationsState> {
  setUnreadNotifCount(count: number) {
    this.state.unreadNotifCount = count
  }
}

export class NotificationsActions extends Actions<
  NotificationsState,
  NotificationsGetters,
  NotificationsMutations,
  NotificationsActions
> {
  async enableCheckNotificationsLoop(enable: boolean) {
    if (enable && !notificationsTimer) {
      await this.actions.getUnreadNotifCount()
      notificationsTimer = setInterval(() => this.actions.getUnreadNotifCount(), 30000)
    } else {
      clearInterval(notificationsTimer)
      notificationsTimer = null
    }
  }

  async getTableItems() {
    const { notifications, count } = await NotificationsService.getNotificationsList({
      limit: this.getters.tableParams.limit,
      offset: this.getters.tableParams.offset,
    })
    this.mutations.setTableCount(count)
    this.mutations.setTableItems(notifications)
  }

  async getUnreadNotifCount() {
    const count = await NotificationsService.notificationsCheck()
    this.mutations.setUnreadNotifCount(parseInt(count))
  }

  async getNotifById(id: number) {
    return await NotificationsService.getNotificationById(id)
  }
}

export const notifications = new Module({
  state: NotificationsState,
  getters: NotificationsGetters,
  mutations: NotificationsMutations,
  actions: NotificationsActions,
  modules: {
    loading,
  },
})
